import { Row, Col, Collapse, Icon } from 'antd';
import React from 'react';

const { Panel } = Collapse;

interface Props {
}

export default ({ }: Props) => {
    return (<Row >

        <Col md={16} offset={4}>
            <h1 style={{ color: 'black', fontSize: 35, paddingTop: '30px', paddingBottom: '25px' }}> WEALTH IPO EDGE FAQ</h1>
            <Collapse accordion bordered={false} expandIconPosition={'right'} defaultActiveKey={['0']} expandIcon={({ isActive }) => <Icon type={isActive ? "minus" : "plus"} style={{ fontSize: 18, fontWeight: 'bold', alignItems: 'right' }} />} >
                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>What is <u>WEALTH IPO EDGE</u>?</h2>} key="1">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        WEALTH IPO EDGE is an online self-service portal that allow users to submit electronic applications of an
                        Initial Public Offering (IPO) or Additional Public Offering (APO) to the Jamaica Central Securities
Depository (JCSD).</p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>How do I access <u>WEALTH IPO EDGE</u>?</h2>} key="2">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        To gain access the platform, potential investors should visit the website: <a target="_blank" href="https://wealthipo.vmbs.com/" >https://wealthipo.vmbs.com/</a>

                    </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Why should I use the <u>WEALTH IPO EDGE</u>?</h2>} key="3">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        The web portals allow clients the opportunity to:

                        <ul>
                            <li>
                                Make, submit, and fund IPO/APO applications online and on the go.
                                </li><li>
                                Avoid in-branch interactions which saves a lot of time for potentials investors.
                                </li><li>
                                Be kept informed throughout each step of the process through email communications
                                </li>
                        </ul>
                    </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Will I still need to submit any documents to the broker?</h2>} key="4">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        No. Prospective investors will no longer be required to submit a physical application form, once all the
                        steps are successfully completed online.
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Will I be able to partake if this is my first experience with the IPO/APO process?</h2>} key="5">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        To engage in an IPO/APO, prospective investors are required to be an active holder of a valid JCSD
                        (Jamaica Central Securities Depository) account with any broker in Jamaica.
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>What is a JCSD Account?</h2>} key="6">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        A JCSD account is an electronic account for holding securities on behalf of an investor at the JCSD. A
                        JCSD account can be opened through any stockbroker in Jamaica.

                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Can I make a request to open a JCSD account via the online platform?</h2>} key="7">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }} >
                        No, not currently. Please contact us at wealthinfo@myvmgroup.com for more information
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Can I use my existing JCSD account(s)?</h2>} key="8">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        Yes, you can use your existing account(s)
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Can I use a JCSD account from a broker other than VM Wealth Management Ltd.?</h2>} key="9">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        Yes. Clients have the option of using any of their existing and active JCSD account(s).
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>If I do not have VM Wealth online credentials, how do I participate?</h2>} key="10">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        All potential investors will be required to create user credentials for this portal. It is <b><u>not</u></b> a requirement
                        to have had any prior engagements or existing accounts with VM Wealth Management Ltd. to access
                        and use this web portal.
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Will I need to visit my Broker/Advisor?</h2>} key="11">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        Once clients submit their applications through <b><u>WEALTH IPO EDGE</u></b>, there will be no need to visit their
                        broker or Wealth Advisor. However, existing VM Wealth Management Ltd. clients who wish to use VM
                        Settlements or Margin Loans to fund their IPO/APO application, will be required to contact their
                        respective advisor to complete that request.
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>How do I fund my IPO/APO application?</h2>} key="12">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        There are currently five (5) methods of funding your application:
                        <ul>
                            <li>
                                In-Bank transfer – funds transferred in branch to the designated bank account.
                            </li>
                            <li>
                                Card Payment- funds transferred online via card.
                            </li>
                            <li>
                                Online Transfer - funds transferred online to the designated bank account.
                                    </li>
                            <li>
                                Brokerage Transfers - funds transferred from another broker to VM Wealth
                                Management Ltd.
                                    </li>
                            <li>
                                Margin Loans – Barrowing against the value of the securities you currently own at VM
                                Wealth.
                                    </li>
                            <li>
                                VM Wealth Settlement
                                </li>
                        </ul>
                    </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>How do I track my application?</h2>} key="13">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        Upon submission of an electronic application, clients will receive email updates on the status of their
                        applications (successful submission, payment approved and shares allocated & refund amounts)

                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Can I cancel an active order via <u>WEALTH IPO EDGE</u>?</h2>} key="14">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        Yes, but once the payment has been verified by a member of the Payments Team, clients will not be
                        able to cancel their application. Payment verification may take 1-2 business days depending on the
                        number of applications.
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>Are all account holders required to give consent to participate?</h2>} key="15">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        Yes. All account holders including joint account holders are required to give consent by uploading
                        signatures before being able to submit application.
                        </p>
                </Panel>

                <Panel header={<h2 style={{ color: '#202020', fontSize: 25 }}>How can I avoid cancellation of my application?</h2>} key="16">
                    <p style={{ color: 'black', fontSize: 18, fontWeight: 'bold' }}>
                        To avoid delays or cancellation, clients are required to complete <b><u>ALL</u></b> areas of the application with special
                        focus given to the below:
                                    <ul>
                            <li>
                                Ensuring a very clear image/scan of your photo ID is provided
                                </li><li>
                                Legible signatures are attached to the application
                                </li><li>
                                Applications are funded with legitimate funding information.
                                </li>
                        </ul>
                    </p>
                </Panel>


            </Collapse>
        </Col>

    </Row>);
}